export const trackEvent = (event: string, category: string, action: string, label: string): void => {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: event,
      EventCategory: category,
      EventAction: action,
      EventLabel: label,
    })
  }
}
